export const presetDelete = async (id) => {
  return await jQuery
    .ajax({
      method: "POST",
      url: pdfp?.ajax_url,
      dataType: "json",
      data: {
        action: "pdf_poster_ajax",
        nonce: pdfp?.nonce,
        model: "Presets",
        method: "delete",
        id,
      },
    })
    .then((res) => res)
    .catch((err) => console.log({ err }));
};

export const getPresets = async () => {
  return await ajaxCall("GET", { model: "Presets", model: "all" });
};

export const ajaxCall = async (method = "GET", data = {}) => {
  return await jQuery
    .ajax({
      method,
      url: pdfp?.ajax_url,
      dataType: "json",
      data: {
        action: "pdf_poster_ajax",
        nonce: pdfp?.nonce,
        ...data,
      },
    })
    .then((res) => res)
    .catch((error) => console.log({ error }));
};
